import React from 'react';

import styles from './Loader.module.scss';

const Loader = () => <div className={styles.loader} />;

export default Loader;
